import axios, { AxiosInstance, CreateAxiosDefaults } from "axios";
import { apiTypeUrlBaseGet } from "./api_common";
import { API_TYPES } from "./api_constants";

function axiosInstanceCreate(
  baseURL: string,
  options?: CreateAxiosDefaults<any>
) {
  const axiosInstance = axios.create({ baseURL, ...options });
  return axiosInstance;
}

const authUrlBase: string = apiTypeUrlBaseGet(API_TYPES.AUTH);

export const axiosAuth: AxiosInstance = axiosInstanceCreate(authUrlBase);

const sakusasUrlBase: string = apiTypeUrlBaseGet(API_TYPES.SAKUSAS);

export const axiosSakusasRad: AxiosInstance =
  axiosInstanceCreate(sakusasUrlBase);

axiosSakusasRad.interceptors.response.use(null, (err) => {
  if (err.response.status === 401) {
    console.log("interceptor err status 401");
    if (!("" in axiosSakusasRad.defaults.headers)) {
      console.log("has no authorization");
      axiosAuth
        .post(
          "bearer/bearer",
          { appName: "express_sakusas" },
          { withCredentials: true }
        )
        .then((bearerResponse) => {
          console.log("bearerResponse", bearerResponse);
          console.log(
            "interceptor Object.keys(axiosSakusasRad.defaults.headers.common).length",
            Object.keys(axiosSakusasRad.defaults.headers.common).length
          );
          axiosSakusasRad.defaults.headers.common[
            "Authorization"
          ] = `Bearer: ${bearerResponse.data.token}`;
          console.log(
            "interceptor Object.keys(axiosSakusasRad.defaults.headers.common).length",
            Object.keys(axiosSakusasRad.defaults.headers.common).length
          );
        });
    }
  }
});
